import { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Input, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import { useLocation, useNavigate } from 'react-router';
import CustomizerContext from '../../_helper/Customizer';
import { getExamList, getExamUser } from '../../store/userExamSlice';


const ExamListTable = () => {
  const location = useLocation();
  const storeVar = useSelector(state => state.examUser)
  const [examId, setExamId] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    setExamId(id);
    dispatch(getExamList(id))
  }, [dispatch, location]);





  const onTestNavigate = (data) => {
    navigate('/exam-history/' + layoutURL + '?userId=' + data.userId + '&mockTestId=' + data.mockTestId)
  }



  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="6">
                
              </Col>
              <Col md="4">
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Exam Name</th>
                  <th scope='col'>Total Score</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.examListData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td >{item.title}</td>
                    <td >{item.totalScore}</td>
                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-secondary action-icon'>
                          <i className="fa fa-book fa-lg" onClick={() => onTestNavigate(item)}></i>
                          <div className="tooltipCustom">Exams Details</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.categoryData?.length <= 0 && (
              <Empty />
            )
          }
        </Card>
        
      </Col>



    </Fragment>
  );
};

export default ExamListTable;
